export default "__VITE_ASSET__BcFwjVW8__"